import {css, html, LitElement} from 'lit';
import {styleMap} from 'lit/directives/style-map.js';
import {customElement, property, state} from 'lit/decorators.js';
import global_css from './global-css';
import Decimal from './break_infinity';

@customElement('smooth-progress')
export class SmoothProgress extends LitElement {
  @property() value = new Decimal(0);
  @property() min = new Decimal(0);
  @property() max = new Decimal(1);
  @property() text = '';
  @property() square = false;

  static override styles = [
    global_css,
    css`
      :host {
        padding: 0px;
      }
      .progress-container {
        background-color: #fff8;
        width: 100%;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
      }
      .progress-container.square {
        border-radius: 0px;
      }
      .progress-bar {
        background-color: rgb(var(--value-color, var(--none-color, black)), 1);
        transition: width 0.5s ease-out;
        height: 100%;
      }

      .progress-bar::before {
        content: attr(data-text);
        white-space: nowrap;
        position: absolute;
        top: calc(50% - 0.6em);
        left: 1ch;
        mix-blend-mode: difference;
        height: 100%;
        width: 100%;
        /* color: #888; */
        color: rgb(var(--value-color, var(--none-color, black)), 1);
        /* --hue: 0;
        --saturation: 100%;
        --lightness: 100%;
        color: hsl(var(--hue), var(--saturation), var(--lightness)); */
        font-weight: bolder;
      }
      slot {
        background-color: transparent;
      }
    `,
  ];

  override render() {
    return html`<div class="progress-container ${this.square ? 'square' : ''}">
      <div
        data-text=${this.text}
        class="progress-bar"
        style=${styleMap({
          width: `${this.value.add(this.min).div(this.max).times(100)}%`,
        })}
      >
        <slot></slot>
      </div>
    </div>`;
  }
}
